import API from "../../restAPI";
const Api = new API();

export default class UsersAPI {
  // get auth user
  getAuthUser(userId) {
    return Api.request("/pr-users/" + userId, [], "GET");
  }

  // get user list
  getuserList(payload) {
    return Api.request("/users-list", payload, "post");
  }

  // get user details
  getUserDetails(userId) {
    return Api.request("/pr-users/" + userId, [], "GET");
  }

  // update user details
  updateUserDetails(payload, userId) {
    return Api.request("/pr-users/" + userId, payload, "PATCH");
  }

  // delete user
  deleteUser(id, payload) {
    return Api.request("/pr-delete-users/" + id, payload, "patch");
  }

  // get user login history
  getUserLoginHistory(payload) {
    return Api.request("/login-history", payload, "POST");
  }

  // get user saved asset list
  getSavedAssetList(payload) {
    return Api.request("/saved-list-admin", payload, "POST");
  }

  // get user saved asset list
  getSendEmailHistory(payload) {
    return Api.request("/fetch-send-email-data-of-saved-list", payload, "POST");
  }

  // get total user count for user report
  getUserListReport(payload) {
    return Api.request("/users-list-by-saved-list", payload, "POST");
  }

  // get total user count for user report
  changePassword(payload) {
    return Api.request("/change-password", payload, "POST");
  }

  // send saved rings user data to email
  sendSavedRingsToEmail(payload) {
    return Api.request("/saved-list-send-email", payload, "POST");
  }
}
